<template>
  <div class="buyerdetailsreview">
    <div class="text-xs-left subheading font-weight-bold ">Buyer Information</div>
    <div class="text-xs-left ma-4">
      {{ name }} ({{ email }})
      <br />
      {{ formatPhone }} <br />

      <div>
        {{ deliveryAddress.street }}<br />
        {{ deliveryAddress.city }}, {{ deliveryAddress.state }} {{ deliveryAddress.zip5 }}
      </div>

      <br />
      <b>Delivery: </b>{{deliveryTypeStr}}<br />
      <b>Payment:</b> {{paymentTypeStr}}
      <br />
      <br />
      <span v-if="note"><b>Note for {{artistName}}:</b> {{note}}</span>

    </div>

</div>

</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'buyerdetailsreview',
  components: {
  },
  data: function () {
    return {
      helpTip: false,
      sendingEmail: false,
      confirmSent: false,
      sendingError: false,
      errMessage: null
    }
  },
  computed: {
    ...mapState({
      artistName: state => state.shopping.name,
      name: state => state.buyerInfo.name,
      email: state => state.buyerInfo.email,
      phone: state => state.buyerInfo.phone,
      deliveryAddress: state => state.cart.deliveryAddress,
      deliveryType: state => state.cart.deliveryType,
      paymentType: state => state.cart.paymentType,
      note: state => state.cart.noteFromBuyer,
      stripeToken: state => state.cart.stripeToken

    }),
    deliveryTypeStr: function () {
      const t = {
        'inperson': this.artistName + ' will deliver your items in person',
        'mail': 'Item will be shipped to you'
      }
      return t[this.deliveryType]
    },
    paymentTypeStr: function () {
      if (this.paymentType === 'inperson') {
        return this.artistName + ' will collect payment in person'
      } else if (this.paymentType === 'creditcard') {
        const ccType = this.stripeToken.card.brand
        return `Your ${ccType} card will be charged`
      } else {
        return null
      }
    },
    formatPhone: function () {
      if (this.phone) {
        return `(${this.phone.substring(0, 3)}) ${this.phone.substring(3, 6)}-${this.phone.substring(6, 10)}  `
      }
    }

  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
